<template>
<modal v-if="display" @close="display=false" title="Please upgrade" btn="Close" @submit="display=false">
  <div>
    It doesn't look like you have access to this feature. You may want to upgrade your account.
    <div class="small-top"><a href="https://habittechnologies.com/pricing/pricing">Click here to learn more about what Habit Technologies can do for you.</a></div>
  </div>
</modal>
</template>

<script>
import modal from "@/components/modal/default";
export default {
  components: { modal },
  data() {
    return {
      display: false
    }
  },
  created() {
    this.$eventHub.$on("upgradeModal", () => {
      this.display = true;
    });
  },
};
</script>

<style>

</style>
